var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"checkout-pnr-information-container"}},[_c('i',{staticClass:"gts-icon icon-status-info"}),_c('span',[_vm._v(_vm._s(_vm.PnrInformations(_vm.handlerPnrCount)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }